import React, { PureComponent } from 'react';
import { t } from 'translations';
import PropTypes from 'prop-types';
import looppa from 'looppa';
import classNames from 'classnames';
import logError from 'util/misc/log-error';
import checkDuplicatedPromotions from '../../util/debug/promotion-code-logger';

class OrderPromotionList extends PureComponent {
    static propTypes = {
        promotions: PropTypes.array.isRequired,
        facet: PropTypes.string,
    };

    state = {};

    componentDidUpdate() {
        checkDuplicatedPromotions({ promotions: this.props.promotions });
    }


    renderPromotion(promotion, key) {
        const translationKey = `order.promotions.${ promotion.code }`;
        let translatedPromo = t(translationKey);
        const translationExists = translationKey !== translatedPromo;

        if (!translationExists && promotion.code !== promotion.name && promotion.name) {
            translatedPromo = promotion.name;
        } else if (!translationExists) {
            logError(new Error(`Unable to translate promotion with key: '${ translationKey }'`), promotion);
        }

        return (
            <div key={key} className="order-promotion-list--item">
                <div className="order-promotion-list--item-label">
                    <span className="order-products-list--marker-text">{translatedPromo}</span>
                </div>
                <div className="order-promotion-list--item-value">
                    -{promotion.amount}
                </div>
            </div>
        );
    }

    render() {
        const { promotions, facet } = this.props;

        return (
            <div className={classNames('order-promotion-list', `order-promotion-list__${ facet }`)}>
                {looppa(promotions)((promotion, i) => (
                    this.renderPromotion(promotion, i)
                ))}
            </div>
        );
    }
}

export default OrderPromotionList;



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/order-promotion-list/index.js